import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=b365b296&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b365b296",
  null
  
)

export default component.exports